import { useTranslation } from "react-i18next"

import TransMsg from '../../transMessage'
import {PageSection} from "../../../components";
import {ResourceLists} from "./ResourceLists";

export const OfficeResources = () => {
    const { t } = useTranslation()
    return (
        <PageSection
            title={t(TransMsg.OFFICE_RESOURCES)}
            description={t(TransMsg.OFFICE_RESOURCES_DESCRIPTION)}
            sectionWrapperSx={{ backgroundColor: "#F8F8F8", pb: "150px" }}
            descriptionSx={{ mt: "18px", fontSize: "16.17px", color: "#393939" }}
            subTitleSx={{ mt: "38px", color: "#A62C4E" }}
            customElement={<ResourceLists t={t} />}
        />
    )
}